import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import $ from 'jquery';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
window.jQuery = $;
window.$ = $;
global.jQuery = $;
require('bootstrap/dist/js/bootstrap.min.js');



ReactDOM.render(
    <Router>
      <App />
    </Router>,
    document.getElementById("root")
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
